import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import Button from 'components/button';
import { HiArrowRight, HiKey } from 'react-icons/hi';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';
import { useState } from 'react';
import UserForm from './userForm';
import PasswordChangeModal from './PasswordChangeModal';

type RowObj = {
  _id: string;
  username: string;
  email: string;
  createdAt: string;
  tracking: { affiliateType: 'Primary' | 'Secondary' };
};

const columnHelper = createColumnHelper<RowObj>();

const filters: IFilter[] = [
  { key: 'username', type: 'text', label: 'Username' },
  { key: 'email', type: 'text', label: 'Email' },
  { key: 'createdAtFrom', type: 'date', label: 'From Date' },
  { key: 'createdAtTo', type: 'date', label: 'To Date' },
  {
    key: 'affiliateType',
    type: 'select',
    options: ['Primary', 'Secondary', 'non-affiliate'],
    label: 'Affilliate Status',
  },
  {
    key: 'showArchived',
    type: 'select',
    options: ['false', 'true'],
    label: 'Archived',
  },
];

const Users = () => {
  const { getApi } = UseApi();
  const [showCreatePackage, setShowCreatePackage] = useState(false);
  const [passwordModal, setPasswordModal] = useState<{
    isOpen: boolean;
    userId: string;
    userName: string;
  }>({ isOpen: false, userId: '', userName: '' });

  async function fetchData(
    options: any,
    filterState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;

    const response = await getApi(
      `users?page=${pageIndex + 1}&limit=${pageSize}${encodeFilters(
        filterState,
      )}`,
    );
    const data = response.data.data.users;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }

  const handleToggleCreatePackage = () => {
    setShowCreatePackage((prevState) => !prevState);
  };

  const handlePasswordChange = (userId: string, userName: string) => {
    setPasswordModal({ isOpen: true, userId, userName });
  };

  const columns = [
    columnHelper.accessor('username', {
      id: 'username',
      header: () => <p className="  ">USERNAME</p>,
      cell: (info) => <p className="  ">{info.getValue() || '-'}</p>,
    }),
    columnHelper.accessor('email', {
      id: 'email',
      header: () => <p className="  ">EMAIL</p>,
      cell: (info) => <p className="  ">{info.getValue()}</p>,
    }),
    columnHelper.accessor('createdAt', {
      id: 'date',
      header: () => <p className="  ">SIGNUP DATE</p>,
      cell: (info) => <p className="  ">{info.getValue()?.substring(0, 10)}</p>,
    }),
    columnHelper.accessor('tracking.affiliateType', {
      id: 'isAffiliate',
      header: () => <p className="  ">AFFILIATE STATUS</p>,
      cell: (info) => <p className="  ">{info.getValue() || '-'}</p>,
    }),
    columnHelper.accessor('_id', {
      id: '_id',
      header: () => <p className="  ">ACTIONS</p>,
      cell: (info) => (
        <div className="flex gap-2">
          <Button 
            type="icon" 
            onClick={() => handlePasswordChange(info.row.original._id, info.row.original.username || info.row.original.email)}
          >
            <HiKey />
          </Button>
          <Link key={1} to={info.getValue()}>
            <Button type="icon">
              <HiArrowRight />
            </Button>
          </Link>
        </div>
      ),
    }),
  ];

  return (
    <div>
      <Button
        onClick={handleToggleCreatePackage}
        extraClasses="ml-auto mr-4 mb-4"
      >
        {showCreatePackage ? 'Back' : 'Add New User'}
      </Button>
      {showCreatePackage ? (
        <UserForm type="Create" handleToggleCreatePackage={handleToggleCreatePackage} />
      ) : (
        <ComplexTable
          columns={columns}
          fetchData={fetchData}
          filters={filters}
        />
      )}
      <PasswordChangeModal
        isOpen={passwordModal.isOpen}
        onClose={() => setPasswordModal({ isOpen: false, userId: '', userName: '' })}
        userId={passwordModal.userId}
        userName={passwordModal.userName}
      />
    </div>
  );
};
export default Users;
